// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { createClient } from "contentful";

import { GenericEntry, PageSectionEntry } from "@src/types";

const Client = createClient({
  space: "o4wst4cqnmfi",
  accessToken: process.env.GATSBY_CONTENTFUL_TOKEN || "",
});

export default Client;

export const parseGeneric = (entry: any, type: string): GenericEntry => {
  const data: GenericEntry = {
    entryId: entry.sys.id,
    name: entry.fields.name || "",
    title: entry.fields.title || "",
    content: entry.fields.content || "",
    image: {
      url: entry.fields.image?.fields.file?.url,
      width: entry.fields.image?.fields.file?.details.image.width,
      height: entry.fields.image?.fields.file?.details.image.height,
    },
    ctaText: entry.fields.ctaText || "",
    ctaUrl: entry.fields.ctaUrl || "",
    ctaLinkType: entry.fields.ctaLinkType || "",
    type: type,
  };

  return data;
};

export const parsePageSection = (entry: any): PageSectionEntry => {
  const data: PageSectionEntry = {
    entryId: entry.sys.id,
    name: entry.fields.name,
    layout: entry.fields.layoutDirection,
    firstSection: entry.fields.firstSection,
    secondSection: entry.fields.secondSection,
  };

  return data;
};
